import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Typography, Card, Button } from "@material-tailwind/react";

import Loader from "../../../../components/Loader";
import { RootState } from "../../../../redux";
import { Vehicle, updateVehicleRequest } from "../../../../redux/vehicles/actions";
import { RenderFormField } from "../../../../components/DetailsFormField";
import { WARRANTY_DETAILS, SECTIONS, renderFeatures, renderShare } from "../New";
import { FormProvider, useForm } from "react-hook-form";
import FormFileUpload from "../../../../components/FormFileUpload";
import AppImages from "../../../../assets/AppImages";


export function DashboardVehicleInventoryTabDetails() {
    const dispatch = useDispatch();
    const methods = useForm();

    const { vehicle, bodies_all, stores, makes_all } = useSelector((state: RootState) => state.vehicles);
    const { constants, features } = useSelector((state: RootState) => state.auth);
    const [isEdit, setIsEdit] = useState(false);
    const [newVehicle, setNewVehicle] = useState<Vehicle>({} as Vehicle);

    useEffect(() => {
        const subscription = methods.watch((value, { name }) => {
            if (!name || !value[name])
                return
            console.log('form', value);
            console.log(`Form field "${name}" changed to`, value[name]);
            if (name === "warranty_type") {
                const warranty = WARRANTY_DETAILS[value[name] as keyof typeof WARRANTY_DETAILS];
                methods.setValue("warranty_details", warranty.details);
                methods.setValue("warranty_coverage", warranty.coverage);
            }
        });
        return () => subscription.unsubscribe();
    }, [methods]);

    useEffect(() => {
        console.log('newVehicle', newVehicle);
    }, [newVehicle]);

    useEffect(() => {
        if (constants) {
            SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f !== "vin") {
                        field.required = false;
                        field.hide = "";
                    }
                    if (field.f === "title_code" && field.options?.length === 0) {
                        field.options = constants.TITLE_TYPES.map((type: any) => ({
                            n: type[1],
                            f: field.f,
                            v: type[0],
                            type: "string",
                        }));
                      } else if (field.f === "drive_type" && field.options?.length === 0) {
                        field.options = constants.VEHICLE_DRIVE_TYPES.map((type: any) => ({
                            n: type[1],
                            f: field.f,
                            v: type[0],
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [constants]);

    useEffect(() => {
        if (vehicle) {
            methods.reset(vehicle);

            if (vehicle?.warranty_type && vehicle.warranty_type in WARRANTY_DETAILS) {
                const warranty = WARRANTY_DETAILS[vehicle.warranty_type as keyof typeof WARRANTY_DETAILS];

                setNewVehicle({
                    ...vehicle,
                    warranty_details: warranty.details,
                    warranty_coverage: warranty.coverage,
                });
            } else {
                setNewVehicle(vehicle);
            }
        }
    }, [vehicle, methods]);

    useEffect(() => {
        if (bodies_all) {
           SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f === "body_id" && field.options?.length === 0) {
                        // @ts-ignore
                        field.options = bodies_all.map((body) => ({
                            n: body.name,
                            f: field.f,
                            v: body.id,
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [bodies_all]);

    useEffect(() => {
        if (makes_all) {
           SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f === "make_obj" && field.options?.length === 0) {
                        // @ts-ignore
                        field.options = makes_all.map((make) => ({
                            n: make.name,
                            f: field.f,
                            v: make.id,
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [makes_all]);

    useEffect(() => {
        if (stores) {
           SECTIONS.forEach((section) => {
                section.fields?.forEach((field) => {
                    if (field.f === "store_id" && field.options?.length === 0) {
                        // @ts-ignore
                        field.options = stores.map((store) => ({
                            n: store.title,
                            f: field.f,
                            v: store.id,
                            type: "string",
                        }));
                    }
                });
            });
        }
    }, [stores]);

    const onFormSubmit = methods.handleSubmit(data => {
        console.log(data);
        setIsEdit(false);

        const all_fields = [
            ...SECTIONS.flatMap(section => section.fields?.map(field => field?.f)),
            "about_img",
            "features",
        ];

        const update_fields = all_fields.filter(
            (field) => field !== undefined && vehicle !== null && field in vehicle && data[field] !== vehicle?.[field as keyof Vehicle]
        ) || [];

        if (update_fields.length === 0) return;

        if (update_fields.indexOf('about_img') !== -1) {
            const reader = new FileReader();
            reader.onloadend = () => {
                data.about_img = reader.result;
                dispatch(
                    updateVehicleRequest({
                        vehicle: data,
                        update_fields: [
                            'id',
                            ...update_fields.filter(field => field !== undefined),
                        ]
                    })
                );
            };
            reader.readAsDataURL(data.about_img[0]);
            return;
        }

        dispatch(
            updateVehicleRequest({
                vehicle: data,
                update_fields: [
                    'id',
                    ...update_fields.filter(field => field !== undefined),
                ]
            })
        );
    });

    return !newVehicle?.id ? (
        <div className="flex justify-center items-center h-full">
            <Loader />
        </div>
    ) : (
        <React.Fragment>
            <FormProvider {...methods}>
                <form
                    className="flex flex-col mt-4"
                    onSubmit={(e) => e.preventDefault()}
                    noValidate
                    autoComplete="off"
                >
                    {SECTIONS.map((section, index) => (
                        <div
                            key={index}
                            className={` ${index === 1 ? "flex justify-between" : ""}`}
                        >
                            <Card className={`p-4 mb-4 ${index === 1 ? "w-full md:w-[79%]" : ""}`}>
                                <div className="flex justify-between">
                                    <div>
                                        <Typography className="text-[16px] text-[#1F2937] font-bold">
                                            {index === 0 ? "Vehicle Details" : section.title}
                                        </Typography>
                                        <Typography className="mt-2 text-[14px] text-[#64748B] font-[450]">
                                            {index === 0
                                                ? "Update your profile information below."
                                                : section.subTitle}
                                        </Typography>
                                    </div>
                                    {index === 0 ? (
                                        <Button
                                            variant="outline"
                                            color="info"
                                            className="h-max"
                                            onClick={() => {
                                                if (isEdit) {
                                                    onFormSubmit();
                                                } else {
                                                    setIsEdit(!isEdit);
                                                }
                                            }}
                                        >
                                            {isEdit ? "Save" : "Edit"}
                                        </Button>
                                    ) : null}
                                </div>

                                {section.type === "render" ? (
                                    <div className={`mt-6 grid grid-cols-1 ${index === 1 ? "md:grid-cols-4" : "md:grid-cols-3"} gap-4`}>
                                        {section.fields?.filter((field) => !field.hide).map((field, fieldIndex) => (
                                            <div key={fieldIndex}>
                                                <RenderFormField
                                                    field={field}
                                                    isEdit={isEdit}
                                                    object={newVehicle}
                                                    setNewObject={setNewVehicle}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                ) : section.type === "features" ? (
                                    renderFeatures(features || [], isEdit)
                                ) : null}

                                {index === 2 ? (
                                    <React.Fragment>
                                       <div
                                            key={index}
                                            className="flex mt-4 flex-col gap-4 border border-[#E2E8F0] rounded-[8px] px-4 py-14 items-center justify-center relative"
                                        >
                                            <FormFileUpload
                                                name="about_img"
                                                accept=".jpg,.png,.jpeg,.pdf"
                                                title="About Image"
                                                gap="gap-y-3"
                                                desc=""
                                                Icon={AppImages.iconFileClip}
                                                show_preview={true}
                                                className="flex-col"
                                                imgClassName="max-w-full"
                                                wrapperClassName="!static"
                                            />
                                        </div>
                                    </React.Fragment>
                                ) : null}
                            </Card>
                            {index === 1 ? (
                                <React.Fragment>
                                    {methods.watch() && renderShare(methods)}
                                </React.Fragment>
                            ) : null}
                        </div>
                    ))}
                </form>
            </FormProvider>
        </React.Fragment>
    );
}
